export default __webpack_public_path__ + "static/media/va2022.58c20819.jpg";